import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Lets any component on the public home page (hero, final CTA, etc.) trigger the Talk to Sales
// modal that lives in home-pricing.component, without owning its open/close state themselves —
// mirrors PlanPromptService's role for the plan-selection prompt.
@Injectable({ providedIn: 'root' })
export class TalkToSalesService {
  private openRequestSubject = new Subject<void>();
  openRequests$ = this.openRequestSubject.asObservable();

  requestOpen(): void {
    this.openRequestSubject.next();
  }
}
